"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shortHash = shortHash;
/** `0x3f9a…c21e`: enough of a transaction hash to recognise it in a message. */
function shortHash(hash) {
    if (hash.length <= 12)
        return hash;
    return `${hash.slice(0, 6)}…${hash.slice(-4)}`;
}
//# sourceMappingURL=hash.js.map